import BaseHeader from './BaseHeader';

const Foot = props => <BaseHeader {...props} Element="tfoot" />;

export default Foot;
